import { render, staticRenderFns } from "./messageSet.vue?vue&type=template&id=c7700b3c&scoped=true"
import script from "./messageSet.vue?vue&type=script&lang=js"
export * from "./messageSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7700b3c",
  null
  
)

export default component.exports